
/**
 * InstrumentInstanceSchedule route definitions
 */
export class InstrumentInstanceScheduleRoutes {

  constructor() {

    // define vars
    this.route_root = 'instrument-instance-schedules';
    this.type_single = 'Lab Instrument Schedule';
    this.type_plural = 'Lab Instrument Schedules';

    /**
     * Define routes array
     * @type {*[]}
     */
    this.routes = [];

    /**
     * Define public routes array
     * @type {Array}
     */
    this.public_routes = [];
  }

  /**
   * Fetch rout definitions statically
   * @returns {*[]|*}
   */
  static fetchRoutes() {
    let this_obj = new this();
    return this_obj.routes;
  }

  /**
   * Fetch public routes array
   * @returns {Array}
   */
  static fetchPublicRoutes() {
    let this_obj = new this();
    return this_obj.public_routes;
  }
}

